import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable()
export class AdminGuard implements CanActivate {

  constructor(private authService: AuthService, private router: Router){}

  canActivate(route: ActivatedRouteSnapshot, router: RouterStateSnapshot): boolean | Promise<boolean> | Observable<boolean | UrlTree> {
    return this.authService.isAuthenticated().pipe(take(1)).pipe(map((user: firebase.User) => {
      var isAuth = user != null && user.uid === environment.adminUid;
      var isLogin: Boolean = router.url.indexOf('admin/login') > -1;

      if (isAuth) {
        if (isLogin) {
          return this.router.createUrlTree(['/admin/practitioners']);
        }
        return true;
      }

      return isLogin ? true : this.router.createUrlTree(['/admin/login']);
    }, (_: any) => {
      return ['/admin/login'];
    }));
  }
}
